import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { actorInfo } from '../../../mocks/portfolio';

const FilmographyHero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-black">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5e5b6cb5516b6b89cbd9521e65cbc4e1.jpg"
          alt="Filmography background"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black"></div>
      </div>

      {/* Navigation */}
      <nav className="relative z-20 px-8 py-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-white font-serif text-2xl font-semibold tracking-wider hover:text-burgundy transition-colors cursor-pointer">
            {actorInfo.initials}
          </Link>
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap">
              Home
            </Link>
            <a href="/#demo-reel" className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap">
              Demo Reel
            </a>
            <a href="/#press" className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap">
              Press
            </a>
            <a href="/#bio" className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap">
              Bio
            </a>
            <a href="/#gallery" className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap">
              Gallery
            </a>
            <a href="/#contact" className="text-white text-sm uppercase tracking-widest hover:text-burgundy transition-colors duration-300 cursor-pointer whitespace-nowrap">
              Contact
            </a>
          </div>
          <Link
            to="/"
            className="px-6 py-2.5 border-2 border-white text-white rounded-full text-sm font-medium hover:bg-white hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Back Home
          </Link>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-8 pt-12 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-burgundy"></div>
            <span className="text-burgundy text-sm uppercase tracking-widest font-medium">Complete Credits</span>
          </div>
          <h1 className="font-serif text-5xl md:text-7xl font-bold text-white mb-4">
            Filmography
          </h1>
          <p className="text-stone-400 text-lg max-w-xl">
            A complete listing of {actorInfo.name}'s film, television, and short film credits as actor, producer, and writer.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FilmographyHero;
